import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

import BoxData from "../../Box";
import CardNav from "../../CardNav";
import { Generaluser } from "@/constants/jsonConstant";
import { images } from "@/constants";
import "../../BussinessMode/style.css";
import { getAsset } from "@/helpers/helper";
import { useGetUserInfoQuery } from "@/features/user/userApiSlice";
import userAvatarImg from "@/assets/images/dummy/user-avatar-img.jpg";

const Generaluserprofile = ({ btn, titleone, titletwo }) => {
  const { name } = useSelector((state) => state.user);
  const [optimisticImage, setOptimisticImage] = useState(null);

  // Fetch user image using RTK Query
  const { data: userInfo, refetch: refetchUserInfo } = useGetUserInfoQuery(name?._id, {
    skip: !name?._id,
  });

  // Listen for image upload events in real-time
  useEffect(() => {
    if (!name?._id) return;

    // Listen for custom image-upload-success event
    const handleImageUpload = (event) => {
      const uploadedImageUrl = event.detail?.imageUrl;
      const userId = event.detail?.userId;

      // Only process if the upload is for the current user
      if (userId === name?._id && uploadedImageUrl) {
        setOptimisticImage(uploadedImageUrl);
        
        // Refetch user data to get the latest image from server
        refetchUserInfo().then((result) => {
          // After refetch, clear optimistic image to show fresh server data
          setTimeout(() => {
            setOptimisticImage(null);
          }, 100);
        }).catch((err) => {
          // Keep optimistic image visible if refetch fails
        });
      }
    };

    window.addEventListener("image-upload-success", handleImageUpload);

    // Also listen for localStorage changes (as a fallback)
    const handleStorageChange = (event) => {
      if (event.key === `profileImageUpdate-${name?._id}`) {
        const storedData = JSON.parse(event.newValue || "{}");
        if (storedData.imageUrl) {
          setOptimisticImage(storedData.imageUrl);
          refetchUserInfo().then(() => {
            setTimeout(() => {
              setOptimisticImage(null);
            }, 100);
          });
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("image-upload-success", handleImageUpload);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [name?._id, refetchUserInfo]);

  // Use optimistic image if available, otherwise use the fetched image
  const getUserImage = () => {
    // First try optimistic image (string format like "/images/filename")
    if (optimisticImage && typeof optimisticImage === "string" && optimisticImage.trim()) {
      return optimisticImage.trim();
    }

    // Then try fetched image (could be array or string)
    const fetchedImage = userInfo?.data?.User?.imageUrl;
    if (Array.isArray(fetchedImage) && fetchedImage.length > 0) {
      const firstImg = fetchedImage[0];
      if (typeof firstImg === "string" && firstImg.trim() && firstImg.trim() !== "null") {
        return firstImg.trim();
      }
    } else if (typeof fetchedImage === "string" && fetchedImage.trim() && fetchedImage.trim() !== "null") {
      return fetchedImage.trim();
    }

    // Then try fallback from Redux state (persisted on reload)
    const reduxImage = name?.imageUrl;
    if (Array.isArray(reduxImage) && reduxImage.length > 0) {
      const firstImg = reduxImage[0];
      if (typeof firstImg === "string" && firstImg.trim() && firstImg.trim() !== "null") {
        return firstImg.trim();
      }
    } else if (typeof reduxImage === "string" && reduxImage.trim() && reduxImage.trim() !== "null") {
      return reduxImage.trim();
    }

    return null;
  };

  const userimg = getUserImage();

  // CardNav dynamic content
  const getCardNavContent = (id) => {
    if (id === 1) {
      // USER PROFILE
      return {
        header: "User Profile",
        para: "User Profile Essentials",
        info: (
          <>
            <p>
              <strong>Creating a SELECTEZI User Profile</strong> is essential because it unlocks all the features and opportunities available on the platform.
            </p>

            <p>
              <strong>Business Connectivity & Networking:</strong> A user profile allows interaction with multiple businesses and enables users to grow within the SELECTEZI ecosystem.
            </p>

            <p>
              <strong>Career & Job Opportunities:</strong> Users can create, update, and manage their <strong>CVs</strong>, increasing their chances of better job opportunities.
            </p>

            <p>
              <strong>Timeline & Activity Management:</strong> Manage multiple timelines to track activities, interactions, and progress.
            </p>

            <p>
              <strong>Business Showcase Shop:</strong> Promote products or services, build visibility, and grow your brand.
            </p>

            <p>
              <strong>Foundation of SELECTEZI:</strong> Every activity on SELECTEZI starts with a User Profile.
            </p>

            <a href="https://www.youtube.com" target="_blank">
              <strong>Click here to see how to handle and manage your Profile</strong>
            </a>
          </>
        ),
      };
    }

    if (id === 2) {
      // USER DASHBOARD
      return {
        header: "User Dashboard",
        para: "Dashboard Overview",
        info: (
          <>
            <p>
              <strong>User Dashboard</strong> is a centralized area that helps users manage and monitor their activities on the platform.
            </p>

            <p>
              <strong>Activity Monitoring & Records:</strong> Track complaints, suggestions, and responses in one place.
            </p>

            <p>
              <strong>Security & Login Information:</strong> View login history, updates, and security-related details.
            </p>

            <p>
              <strong>User ID & Settings Management:</strong> Manage personal details, preferences, and account configurations easily.
            </p>

            <p>
              <strong>Control, Transparency & Convenience:</strong> All important account-related information is organized in one place.
            </p>

            <a href="https://www.youtube.com" target="_blank">
              <strong>Click here to see how to handle and manage the User Dashboard</strong>
            </a>
          </>
        ),
      };
    }

    return {};
  };

  return (
    <div>
      <Row>
        {Generaluser.map((data) => {
          const cardContent = getCardNavContent(data.id);

          return (
            <Col lg="6" md="6" sm="6" xs="6" key={data.id}>
              {/* CardNav Section */}
              <CardNav
                Header={cardContent.header}
                para={cardContent.para}
                myid={data.id}
                myinfo={cardContent.info}
              />

              {/* Box Section */}
              <Card className="shadow-joboprt mt-lg-2 mt-md-3 mt-sm-3">
                {data.id === 1 && (
                  <BoxData
                    Title={titleone}
                    Butonn={data.info}
                    imgg={
                      userimg
                        ? getAsset(userimg)
                        : images.noprofile
                    }
                    ms="nine-element"
                    buy="nine"
                    link="/user-profile"
                  />
                )}

                {data.id === 2 && (
                  <BoxData
                    Title={titletwo}
                    Butonn={data.info}
                    imgg={images.Businessdashboard}
                    link="/user-dashboard"
                    ms="ten-element"
                    buy="ten"
                  />
                )}
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default Generaluserprofile;
